import * as React from "react";
import styled from "styled-components";
import {BoxHeader} from "./box-header";
import {BoxBody} from "./box-body";
import {Box} from "@material-ui/core";

export const BoxWrapper: React.FC<Props> = ({children, title, style}) => (
    <StyledBox flexDirection={'column'} style={style}>
        <BoxHeader title={title} />
        <BoxBody children={children} />
    </StyledBox>
);

const StyledBox = styled(Box)`
    
`

interface Props {
    title: string;
    style?: {};
}
